import { Routes, Route } from 'react-router-dom';
import React from 'react';
import './App.css';
import BookingPage from './Resort/Booking/BookingPage.js';
import { HotelRoomDisplay } from './Resort/HotelRoom/HotelRoomDisplay.js';
import { HotelRoomDetail } from './Resort/HotelRoom/HotelRoomDetail.js';
import TopBar from './Comonents/Navbar/Topbar/Topbar';
import Navbar from './Comonents/Navbar/Navbar';
import Home from './Comonents/Home/Home';
import NoticeUpdate from './Comonents/Notice/NoticeUpdate/NoticeUpdate';
import NoticeBoard from './Comonents/Notice/NoticeBoard/NoticeBoard';
import UploadImages from './Comonents/Outdoor/UploadImages';
import AICTE from './Comonents/RecFacilities/RecFacilities';
import AICTEUpload from './Comonents/RecFacilities/AICTEUpload';
import Footer from './Comonents/Footer/Footer';

import AboutUs from './Comonents/About/AboutUs/AboutUs';
import FacilitiesBanquet from './Comonents/Home/HComponents/Facilities/Facilities';

import BookingDashboard from './Resort/Booking/BookingDashboard';
import BanquiteFacilites from './Comonents/Banquite/Banquite';
import Gallery from './Comonents/Gallery/Gallery';
import OutDoor from './Comonents/Outdoor/Outdoor';

import Login from './Admin/User/Login';
import Register from './Admin/User/Register';
import BookInquiry from './Admin/NewStudentInquiry/NewStudentInquiry';
import ReceiveInquiry from './Admin/ReceiveInquiry/ReceiveInquiry';
import PrivateRoute from './Admin/PrivateRoute/PrivateRoute';
import AddAmenties from './Comonents/Amenties/Amenties';
import LoaderPage from './Comonents/Loader/Load';
import { ContactUs } from './Comonents/Contact/ContactUs.js';
import { HotelRooms } from './Resort/HotelRoom/HotelRooms.js';
import HotelRoomUplod from './Resort/HotelRoom/HotelRoomUpload.js';
import Dashboard from './Admin/Dashboard/Dashboard.js';
import PopupContact from './Comonents/Contact/PopupContact/PopupContact.js';
import Popupinquiry from './Admin/Popupinquiry/Popupinquiry.js';
import ContactFormPage from './Comonents/Popcontact1/Popcontact1.js';



function App() {
    return (
        <div className="App">
            <TopBar />
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/updatenotice" element={<NoticeUpdate />} />
                <Route path="/notice" element={<NoticeBoard />} />
                <Route path="/outdoor" element={<OutDoor />} />
                <Route path="/amenties" element={<AddAmenties />} />
                <Route path="/recreational-facilities" element={<AICTE />} />
                <Route path="/aicte-upload" element={<AICTEUpload />} />
               
                <Route path="/about" element={<AboutUs />} />
                <Route path="/Banquite-facilities" element={<BanquiteFacilites />} />
                <Route path="/loader" element={<LoaderPage />} />
                <Route path="/facilities" element={<FacilitiesBanquet />} />
               
                <Route path="/rooms" element={<HotelRooms />} />
                
                <Route path="/hotel-rooms" element={<HotelRoomDisplay />} />
                <Route path="/room/:roomId" element={<HotelRoomDetail />} />
                <Route path='/booking/:roomId' element={<BookingPage/>} />
                <Route path="/bookingDashboard" element={<BookingDashboard />} />
                <Route path="/gallery" element={<Gallery />} />
                
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/receive" element={<ReceiveInquiry />} />
                <Route path="/inquiry" element={<BookInquiry />} />
                
                <Route path="/popupcontact" element={<PopupContact />} />
                
                
                <Route path="/contact" element={<ContactUs />} />
                {/* <Route path="/popupcontactt" element={<Popcontact />} /> */}
                <Route path="/popupcontactt" element={<ContactFormPage />} />


                
                <Route path="/dashboard" element={<PrivateRoute><Dashboard/></PrivateRoute>} />
                <Route path="/contact-inquiry" element={<PrivateRoute><ReceiveInquiry/></PrivateRoute>} />
                <Route path="/Booking-inquiry" element={<PrivateRoute><BookingDashboard/></PrivateRoute>} />
                <Route path="/ad-inquiry" element={<PrivateRoute><Popupinquiry/></PrivateRoute>} />




                <Route path="/upload-hotel" element={<PrivateRoute><HotelRoomUplod/></PrivateRoute>} />
                <Route path="/register" element={<PrivateRoute><Register/></PrivateRoute>} />
                <Route path="/gallery-upload" element={<PrivateRoute><UploadImages /></PrivateRoute>} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;
